import { getToken } from "../../services/HttpService";
export const createSchema = async (model) =>{

   
    const endPoint = `${process.env.REACT_APP_API}/archives`;
    const response = await getToken();

    const resp = await fetch(endPoint,{
        headers: {
            Authorization: `Bearer ${response.token}`,
            "Content-Type": "application/json"
        },
        method: 'POST',
        body: JSON.stringify(model)
    })

    return await resp.json();
}